import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import showToast from '@/utils/toasts';
import UpdatedToast from '@/components/toasts/UpdatedToast';
import ErrorToast from '@/components/toasts/ErrorToast';
import actions from '../constants';

export function* datasetConditionToast({ code, name }) {
  yield call(showToast, <UpdatedToast code={code} name={name} />);
}

export function* datasetConditionErrorToast({ name }) {
  yield call(showToast, <ErrorToast operation="actions.update" name={name} />);
}

export function* datasetConditionDownloadErrorToast({ datasetCondition }) {
  yield call(showToast, <ErrorToast operation="actions.download" name={datasetCondition.condition.name} />);
}

export default function* datasetConditionsToasts() {
  yield takeEvery(
    [
      actions.ADD_DATASET_CONDITION_SUCCESS,
      actions.UPDATE_DATASET_CONDITION_SUCCESS,
      actions.REMOVE_DATASET_CONDITION_SUCCESS,
    ],
    datasetConditionToast,
  );
  yield takeEvery(
    [actions.TOGGLE_DATASET_CONDITION_ADVISORY_ERROR, actions.REMOVE_DATASET_CONDITION_ERROR],
    datasetConditionErrorToast,
  );
  yield takeEvery(actions.DOWNLOAD_DATASET_CONDITION_ATTACHMENT_ERROR, datasetConditionDownloadErrorToast);
}
